import React from 'react';
import Layout from '../dashboard/layouts/layout';
import DashboardDocuments from './content/dashboard-documents';

function Dashboard() {
    return (
        <Layout>
            <DashboardDocuments />
        </Layout>
    );
}

export default Dashboard;